import type { MapStyle } from '../map-types';

const MAP_WORKER_URL = 'https://maplibre.utils.elfsightcdn.com';

const STYLE_MAP = {
  classic: 'osm_bright',
  light: 'alidade_smooth',
  dark: 'alidade_smooth_dark',
  blackInk: 'stamen_toner',
  shadesOfGreen: 'stamen_terrain'
  // satellite: 'alidade_satellite
};

export function getStyleURL(style: MapStyle, widgetToken?: string) {
  const url = new URL(MAP_WORKER_URL);
  url.searchParams.append('style', STYLE_MAP[style]);
  if (widgetToken) {
    url.searchParams.append('widgetToken', widgetToken);
  }

  return url.toString();
}
